import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateUpdateManagerVacancy = {
  updateManagerVacancy: { data: null, loading: false, error: null },
};

export const updateManagerVacancy = createAsyncThunk('user/updateManagerVacancy', async ({ id, ...data }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/vacancies/${id}/manager`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUpdateManagerVacancy = {
  [updateManagerVacancy.pending]: (state) => {
    state.updateManagerVacancy.loading = true;
    state.updateManagerVacancy.error = null;
  },
  [updateManagerVacancy.fulfilled]: (state, action) => {
    state.updateManagerVacancy.loading = false;
    state.updateManagerVacancy.data = action.payload;
    state.updateManagerVacancy.error = null;
  },
  [updateManagerVacancy.rejected]: (state, action) => {
    state.updateManagerVacancy.loading = false;
    state.updateManagerVacancy.error = true;
  },
};
